module.exports = __webpack_public_path__ + "static/social-ddf-cover-6ce70be43d985754822af2ff8e1fdfcc.png";